import { cn } from 'utils/styles';
import { CarouselButton, CarouselPaginationProps } from 'components/shared/Carousel/CarouselPagination';

type CarouselNumericPaginationProps = Pick<CarouselPaginationProps, 'total' | 'current' | 'className' | 'testId'>;

const CarouselNumericPagination = ({ total, current, className, testId }: CarouselNumericPaginationProps) => {
  const testFixture = `${testId ?? 'carousel'}`;
  return (
    <div data-testid={`${testFixture}-pagination`} className={cn('flex items-center gap-2.5 h-full', className)}>
      <CarouselButton direction="prev" className={'text-(--pagination-arrow)'} />
      <div className="font-sans text-label-saans">
        <span className="border-[1.5px] border-solid border-current rounded-md px-3 py-2 inline-block mr-1.5">
          {current + 1}
        </span>
        of {total}
      </div>
      <CarouselButton direction="next" className={'text-(--pagination-arrow)'} />
    </div>
  );
};

export default CarouselNumericPagination;
